import React, { FC } from "react";
import { IconType } from "./types";

export const WarningIcon: FC<IconType> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="15"
    viewBox="0 0 18 15"
  >
    <path
      d="M17.5325 12.8758L10.2017 0.68C9.94582 0.254167 9.49665 0 8.99999 0C8.50332 0 8.05415 0.254167 7.79915 0.679167L0.467485 12.8758C0.207485 13.3083 0.200818 13.8492 0.449152 14.2883C0.696652 14.7275 1.16415 15 1.66915 15H16.3317C16.8358 15 17.3041 14.7275 17.5516 14.2883C17.8 13.8492 17.7925 13.3083 17.5325 12.8758ZM9.41665 12.5H8.58332C8.35332 12.5 8.16665 12.3133 8.16665 12.0833V11.25C8.16665 11.02 8.35332 10.8333 8.58332 10.8333H9.41665C9.64665 10.8333 9.83332 11.02 9.83332 11.25V12.0833C9.83332 12.3133 9.64665 12.5 9.41665 12.5ZM8.99999 9.16667C8.53999 9.16667 8.16665 8.79333 8.16665 8.33333V5.83333C8.16665 5.37333 8.53999 5 8.99999 5C9.45998 5 9.83332 5.37333 9.83332 5.83333V8.33333C9.83332 8.79333 9.45998 9.16667 8.99999 9.16667Z"
      fill="#FF7B00"
    />
  </svg>
);
